import Chosen from "../../../forms/Inputs/Select/Chosen";
import RentalVehicles from "../../rental_vehicles";

const VehicleSimilar = {
    init() {
        this.el = $('[module="rental"].similar');

        if (!this.el.length) {
            return;
        }

        Chosen.init(this.el);

        this.selectStatus = this.el.find('select.changeSimilarVehicle');
        this.bind();
    },

    bind() {
        this.selectStatus.on('change', VehicleSimilar.changeSimilarVehicle);
    },

    changeSimilarVehicle() {
        RentalVehicles.load(null, {event: 'changeSimilarVehicle', similarVehicles: VehicleSimilar.vehiclesList()});
        return false;
    },

    vehiclesList() {
        let similarVehicles = {};

        VehicleSimilar.el.find("select").each(function (index, select) {
            // Get the selected value
            let selectedValue = $(select).val();

            if (selectedValue === 'none') {
                selectedValue = $(select).parents().closest(".vehicleWrap").find("[item]").attr("item");
            }
            // Store the selected value in the object
            similarVehicles[index] = selectedValue;
        });

        return similarVehicles;
    },

    replaceVehicles(response) {
        let html = $('<div>').hide().empty().html(response);
        const vehicles = html.children();

        VehicleSimilar.el.empty().append(vehicles);
        VehicleSimilar.init();
    },
}
export default VehicleSimilar;